import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import DashboardPage from './pages/Dashboard/DashboardPage';
import UserLookupPage from './pages/ClientLookup/ClientLookupPage';
import AuditLogsPage from './pages/AuditLogs/AuditLogsPage';
import SignInSide from './auth/components/SignInSide';
import Splash from './auth/components/Splash';
import { AuthProvider } from './auth/AuthContext';
import AuthCallback from './auth/components/AuthCallback';
import ProtectedRoute from './auth/components/ProtectedRoute';
import RoleRoute from './auth/components/RoleRoute';
import { ACCESS_DENIED_PATH, APP_PATHS } from './auth/role-based-access-control';
// import TransactionsPage from './pages/Transactions/TransactionsPage';
import AccessDeniedPage from './pages/AccessDenied/AccessDeniedPage';
import ReconciliationPage from './pages/Reconciliation/ReconciliationPage';
import BulkSmsPage from './pages/BulkSms/BulkSmsPage';
import BulkSmsHistoryPage from './pages/BulkSms/BulkSmsHistoryPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Splash />} />
          <Route path="/signin" element={<SignInSide />} />
          {/* <Route path="/signup" element={<SignUp />} /> */}
          <Route path="/auth/callback" element={<AuthCallback />} />
          {/* Pathless layout route — sidebar/navbar shared across all three pages */}
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route
              path={APP_PATHS.DASHBOARD}
              element={(
                <RoleRoute path={APP_PATHS.DASHBOARD}>
                  <DashboardPage />
                </RoleRoute>
              )}
            />
            <Route
              path={APP_PATHS.CLIENT_LOOKUP}
              element={(
                <RoleRoute path={APP_PATHS.CLIENT_LOOKUP}>
                  <UserLookupPage />
                </RoleRoute>
              )}
            />
            <Route
              path={APP_PATHS.CLIENT_CHANGES_LOG}
              element={(
                <RoleRoute path={APP_PATHS.CLIENT_CHANGES_LOG}>
                  <AuditLogsPage forcedScope="contact" title="Contact updates logs" />
                </RoleRoute>
              )}
            />
            <Route path="/user-lookup" element={<Navigate to={APP_PATHS.CLIENT_LOOKUP} replace />} />
            {/* All Audit Logs temporarily disabled
            <Route
              path={APP_PATHS.AUDIT_LOGS}
              element={(
                <RoleRoute path={APP_PATHS.AUDIT_LOGS}>
                  <AuditLogsPage />
                </RoleRoute>
              )}
            />
            */}
            {/* Transactions pages temporarily disabled
            <Route
              path={APP_PATHS.TRANSACTIONS}
              element={(
                <RoleRoute path={APP_PATHS.TRANSACTIONS}>
                  <Navigate to={APP_PATHS.TRANSACTIONS_DEPOSITS} replace />
                </RoleRoute>
              )}
            />
            <Route
              path={APP_PATHS.TRANSACTIONS_DEPOSITS}
              element={(
                <RoleRoute path={APP_PATHS.TRANSACTIONS_DEPOSITS}>
                  <TransactionsPage initialKind="deposits" hideKindToggle />
                </RoleRoute>
              )}
            />
            <Route
              path={APP_PATHS.TRANSACTIONS_WITHDRAWALS}
              element={(
                <RoleRoute path={APP_PATHS.TRANSACTIONS_WITHDRAWALS}>
                  <TransactionsPage initialKind="withdrawals" hideKindToggle />
                </RoleRoute>
              )}
            />
            <Route
              path={APP_PATHS.TRANSACTIONS_AUDITS}
              element={(
                <RoleRoute path={APP_PATHS.TRANSACTIONS_AUDITS}>
                  <AuditLogsPage forcedScope="transactions" title="Transaction Logs" />
                </RoleRoute>
              )}
            />
            */}
            <Route
              path={APP_PATHS.RECONCILIATION}
              element={(
                <RoleRoute path={APP_PATHS.RECONCILIATION}>
                  <ReconciliationPage />
                </RoleRoute>
              )}
            />
            <Route
              path={APP_PATHS.BULK_SMS}
              element={(
                <RoleRoute path={APP_PATHS.BULK_SMS}>
                  <BulkSmsPage />
                </RoleRoute>
              )}
            />
            <Route
              path={APP_PATHS.BULK_SMS_HISTORY}
              element={(
                <RoleRoute path={APP_PATHS.BULK_SMS_HISTORY}>
                  <BulkSmsHistoryPage />
                </RoleRoute>
              )}
            />
            <Route path={ACCESS_DENIED_PATH} element={<AccessDeniedPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
